var map = {
	"./heavy_armor_1.png": "66e7",
	"./heavy_armor_2.png": "be15",
	"./heavy_armor_3.png": "c331",
	"./heavy_armor_4.png": "e39e",
	"./heavy_armor_5.png": "6f10",
	"./heavy_armor_6.png": "2447",
	"./light_armor_1.png": "f809",
	"./light_armor_2.png": "0797",
	"./light_armor_3.png": "730b",
	"./light_armor_4.png": "dd14",
	"./light_armor_5.png": "804a",
	"./light_armor_6.png": "a359",
	"./light_armor_7.png": "09ec",
	"./medium_armor_1.png": "08c0",
	"./medium_armor_2.png": "b0e6",
	"./medium_armor_3.png": "8d31",
	"./medium_armor_4.png": "a413",
	"./medium_armor_5.png": "ceee",
	"./medium_armor_6.png": "3feb",
	"./medium_armor_7.png": "cb7a",
	"./shield_1.png": "5cfc",
	"./shield_2.png": "66eb",
	"./shield_3.png": "308b",
	"./shield_4.png": "41e4",
	"./shield_5.png": "06d1",
	"./shield_6.png": "d9eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c529";